import React from 'react';
import {
  ArrowLeftIcon,
  ArrowDownIcon,
  CloseIcon,
  EmailSuccessIcon,
  EventIcon,
  InfoIcon,
  LogoutIcon,
  MailIcon,
  PaymentIcon,
  ProfileIcon,
  TeamsIcon,
  TeamInfoIcon,
  TrophyIcon,
  WatchIcon,
  LockIcon,
  TickIcon,
  UploadIcon,
  PlayIcon,
  CircularTick,
  DeleteIcon,
  TransactionIcon,
  MunicipalityIcon,
  UserIcon,
  LoaderIcon,
  CurrentTransactionIcon,
  CompletedTransactionIcon,
  CalenderIcon,
  DocumentIcon,
  ArrowUpIcon,
  DownArrow,
  ViewIcon,
  DownloadIcon,
  CheckMark,
  AlertIcon,
} from './icons';

export const iconNames = {
  arrowLeft: ArrowLeftIcon,
  arrowDown: ArrowDownIcon,
  close: CloseIcon,
  emailSuccess: EmailSuccessIcon,
  event: EventIcon,
  info: InfoIcon,
  logout: LogoutIcon,
  mail: MailIcon,
  payment: PaymentIcon,
  profile: ProfileIcon,
  teams: TeamsIcon,
  teamInfo: TeamInfoIcon,
  trophy: TrophyIcon,
  watch: WatchIcon,
  lock: LockIcon,
  tick: TickIcon,
  upload: UploadIcon,
  play: PlayIcon,
  circletick: CircularTick,
  delete: DeleteIcon,
  transaction: TransactionIcon,
  municipality: MunicipalityIcon,
  user: UserIcon,
  loader: LoaderIcon,
  current_transaction: CurrentTransactionIcon,
  completed_transaction: CompletedTransactionIcon,
  calender: CalenderIcon,
  documentIcon: DocumentIcon,
  arrowUpIcon: ArrowUpIcon,
  downArrow: DownArrow,
  viewIcon: ViewIcon,
  downloadIcon: DownloadIcon,
  checkmark: CheckMark,
  alertIcon: AlertIcon,
};

export type IconProps = {
  name: keyof typeof iconNames;
};
export default function Icon({ name }: IconProps) {
  const IconComponent = iconNames[name];
  return <IconComponent />;
}
